var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayExtraSmallCustomX = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.742 3.258a1.072 1.072 0 0 0-1.516 0L10 8.484 4.774 3.258a1.072 1.072 0 1 0-1.516 1.516L8.484 10l-5.226 5.226a1.072 1.072 0 1 0 1.516 1.516L10 11.516l5.226 5.226a1.072 1.072 0 1 0 1.516-1.516L11.516 10l5.226-5.226a1.072 1.072 0 0 0 0-1.516z",
    fill: "#DD544A",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayExtraSmallCustomX);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-extra-small-custom-x.32db8be333b2edf65a29fac1bc0f981c.svg";